<template>
	<div class="section-sidebar" :class="{ 'app-bar-collapsed': appBarCollapsed }">
		<ul class="section-sidebar-nav">
			<slot></slot>
		</ul>
	</div>
</template>

<script>
export default {
	computed: {
		/**
		 * Returns the `appBarCollapsed` property from the store.
		 *
		 * @returns {boolean}
		 */
		appBarCollapsed () {
			return this.$store.getters['ui/appBarCollapsed'];
		}
	}
};
</script>

<style lang="scss">
@import "../../_variables.scss";

.section-sidebar {
	position: fixed;
	top: $app-topbar-height;
	left: $app-sidebar-width;
	bottom: 0;
	width: $section-sidebar-width;
	background-color: $section-sidebar-bg;
	overflow-y: auto;
	border-right: $section-sidebar-border;

	&.app-bar-collapsed {
		left: $app-sidebar-collapsed-width;
	}

	.section-sidebar-nav {
		position: absolute;
		top: 0;
		right: 0;
		left: 0;
		margin: 0;
		padding: 0;
		list-style-type: none;
	}
}
</style>
